const $ = jQuery.noConflict();
import '@fancyapps/fancybox';

('use strict');

const ProductGallery = {
	/**
	 * @description Initialize Fancybox for gallery
	 */
	init: function() {
		this.setupGallery();
		this.updateStickyHeight();
		this.handleStickyAttrs();

		window.addEventListener('resize', () => {
			this.updateStickyHeight();
			this.handleStickyAttrs();
		});

		window.addEventListener('scroll', () => {
			this.handleStickyAttrs();
		});
	},

	/**
	 * @description Sets up Fancybox with vertical scrolling
	 */
	setupGallery: function() {
		$(document).on(
			'click',
			'.js-product-gallery-popup-trigger',
			function() {
				const index = parseInt($(this).attr('data-index'), 10);

				$.fancybox.open({
					src: '.js-product-gallery-popup',
					type: 'inline',
					baseClass: 'product-gallery__popup-wrap',
					smallBtn: true,
					touch: false,
					video: {
						autoStart: false,
					},
					afterShow: function() {
						const popup = document.querySelector(
							'.js-product-gallery-popup'
						);
						if (!popup) return;

						setTimeout(() => {
							const target = popup.querySelectorAll(
								'.product-gallery__popup-media'
							)[index];
							if (target) {
								target.scrollIntoView({
									behavior: 'smooth',
									block: 'start',
								});
							}
						}, 300);
					},
					afterClose: function() {
						const popup = document.querySelector(
							'.js-product-gallery-popup'
						);
						if (!popup) return;

						// Stop HTML5 Videos
						popup.querySelectorAll('video').forEach((video) => {
							video.pause();
							video.currentTime = 0;
						});

						// Stop YouTube Iframes
						popup.querySelectorAll('iframe').forEach((iframe) => {
							const src = iframe.getAttribute('src');
							if (src) iframe.setAttribute('src', src); // reload iframe stops playback
						});
					},
				});
			}
		);
	},

	/**
	 * @description Handles sticky positioning for content when it reaches bottom of viewport
	 */
	handleStickyAttrs: function() {
		if (window.innerWidth <= 767) return;

		const contentInner = document.querySelector(
			'.product-main__content-inner'
		);
		if (!contentInner) return;

		const rect = contentInner.getBoundingClientRect();
		const windowHeight = window.innerHeight;

		// Add sticky class when bottom of content reaches bottom of viewport
		if (
			rect.bottom <= windowHeight &&
			!contentInner.classList.contains('is-sticky')
		) {
			contentInner.classList.add('is-sticky');
		} else if (
			rect.bottom > windowHeight &&
			contentInner.classList.contains('is-sticky')
		) {
			contentInner.classList.remove('is-sticky');
		}
	},

	/**
	 * @description Calculates and sets height for sticky parent (only > 767px)
	 */
	updateStickyHeight: function() {
		if (window.innerWidth <= 767) return;

		const row = document.querySelector('.js-product-main-row');
		const attrsWrap = document.querySelector('.js-product-attrs-wrap');
		const mediaItems = document.querySelector(
			'.js-product-gallery-media-items'
		);

		if (!row || !attrsWrap || !mediaItems) return;

		const attrsWrapHeight = attrsWrap.getBoundingClientRect().height;
		const galleryHeight = mediaItems.getBoundingClientRect().height;

		const galleryRect = mediaItems.getBoundingClientRect();
		const visibleGalleryHeight = Math.max(
			0,
			Math.min(galleryRect.bottom, window.innerHeight) -
				Math.max(galleryRect.top, 0)
		);

		const totalHeight =
			attrsWrapHeight + galleryHeight - visibleGalleryHeight + 100;

		row.style.minHeight = `${totalHeight}px`;
	},
};

export default ProductGallery;
